/**
 * JLL color palette
 */
export class ColorPalette {
  /**
   * Gets the color for the amount of entries and the current entry. If the palette es exceeded, black is returned
   * @param numEntries
   * @param index
   * @returns
   */
  public getColor(numEntries: number, index: number): string {
    try {
      const palette = this.getColorPalette(numEntries);

      if (index >= 0 && index < palette.length) {
        return palette[index];
      }
    } catch (ex) {
      //Ignore
    }
    return '#000000';
  }

  /**
   * Gets a color palette with the specified amount of entries. The maximum amount is pre-defined and new values will not be interpolated!
   * @param numEntries
   */
  public getColorPalette(numEntries): string[] {
    const concrete = "#B1B2B4"
    const steel = "#626468";
    const black = "#000000"
    const stone = "#DBD6C7"
    const pantone = "#E30613"

    const mid_concrete = "#d4d5d6";
    const mid_purple = "#9870a6";
    const mid_steel = "#999a9d";
    const light_stone = "#e6e1d8";
    const light_blue = "#abc0e7";
    const yellow = "#ffeeab";
    const light_orange = "#ffb87f";

    const colorPalette = [concrete, steel, black, stone, pantone, mid_concrete, mid_purple, mid_steel, light_stone, light_blue, yellow, light_orange];
    const result: string[] = [];
    try {
      for (let i = 0; i < numEntries; ++i) {
        result.push(colorPalette[i > colorPalette.length ? i % colorPalette.length : i]);
      }
    } catch (ex) {
      //Ignore
    }
    return result;
  }
}
